import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import Reveal from "../components/ui/Reveal";
import { HiOutlineCheckCircle } from "react-icons/hi";
import Stats from "../components/ui/Stats";
import heroImg from "../assets/a2.jpg"; // tu imagen
import heroki from "../assets/a9.png"
import ScrollToTop from "../components/ui/ScrollToTop";
import LogoMarquee from "../components/home/LogoMarquee";
import SEO from "../components/SEO";

const About = () => {

  const heroRef = useRef(null);

  const { scrollYProgress } = useScroll({
    target: heroRef,
    offset: ["start start", "end start"]
  });

  const y = useTransform(scrollYProgress, [0, 1], ["0%", "35%"]);

  return (
    <div className="pt-32">
      <SEO
        title="Sobre Planix | Planos Arquitectónicos e Ingeniería"
        description="Conoce Planix, plataforma especializada en planos arquitectónicos, diseño de viviendas, topografía y soluciones de ingeniería civil."
        canonical="https://www.planixapp.com/nosotros"
        image="https://www.planixapp.com/cover.jpg"
        structuredData={{
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "Planix",
          "url": "https://www.planixapp.com/nosotros",
          "logo": "https://www.planixapp.com/cover.jpg",
          "description": "Plataforma especializada en planos arquitectónicos e ingeniería.",
          "sameAs": [
            "https://instagram.com/planix",
            "https://facebook.com/planix"
          ]
        }}
      />

      <ScrollToTop />

      {/* HERO PARALLAX */}
      <section
        ref={heroRef}
        className="relative h-[420px] md:h-[520px] overflow-hidden"
      >

        {/* Imagen parallax */}
        <motion.img
          src={heroImg}
          alt="Sobre Planix"
          style={{ y }}
          className="absolute top-0 left-0 w-full h-[130%] object-cover"
        />

        {/* overlay */}
        <div className="absolute inset-0 bg-black/50"></div>

        {/* contenido */}
        <div className="relative flex flex-col justify-center items-center text-center h-full px-6">

          <Reveal>
            <h1 className="text-4xl md:text-5xl font-bold text-white">
              Sobre <span className="text-[#F26B1D]">Planix</span>
            </h1>
          </Reveal>

          <Reveal>
            <p className="mt-6 max-w-2xl mx-auto text-gray-200 leading-relaxed">
              Somos una plataforma especializada en servicios técnicos y
              soluciones prediales, orientada a facilitar el acceso a planos
              profesionales y asesoría en saneamiento físico legal.
            </p>
          </Reveal>

        </div>

      </section>

      {/* QUIENES SOMOS */}
      <section className="py-24 bg-white">
        <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-2 gap-16 items-center">

          <Reveal>
            <div>
              <h2 className="text-3xl font-bold text-[#1C1C1C]">
                Experiencia técnica y soluciones claras
              </h2>

              <p className="mt-6 text-gray-600 leading-relaxed">
                En Planix trabajamos con un enfoque técnico y profesional para
                brindar soluciones en saneamiento físico legal, elaboración de
                planos y asesoría predial.
              </p>

              <p className="mt-4 text-gray-600 leading-relaxed">
                Combinamos experiencia en gestión predial con herramientas
                digitales para ofrecer servicios eficientes y accesibles.
              </p>

              <p className="mt-6 text-gray-600 leading-relaxed">
                En <strong>Planix</strong>, integramos la precisión de la <strong>ingeniería civil</strong> con la normativa legal vigente para ofrecer soluciones reales en el saneamiento físico legal de predios en Lima y todo el Perú.
              </p>

              <p className="mt-4 text-gray-600 leading-relaxed">
                Nuestro equipo facilita procesos complejos como la <strong>independización, subdivisión de lotes y declaratorias de fábrica</strong>, asegurando que cada plano técnico cumpla con los estándares de SUNARP y municipalidades.
              </p>
            </div>
          </Reveal>

          <Reveal>
            <div className="bg-gray-100 rounded-2xl overflow-hidden shadow-inner border border-gray-200">
              <img src={heroki} alt="Elaboración de planos técnicos profesionales en Perú - Planix" className="w-full h-full object-cover" />
            </div>
          </Reveal>

        </div>
      </section>

      {/* MISION VISION - RE-ESTRUCTURADO */}
      <section className="py-24 bg-gray-50">
        <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-2 gap-12">

          {/* Tarjeta Misión */}
          <motion.div
            whileHover={{ y: -10, shadow: "0 20px 25px -5px rgb(0 0 0 / 0.1)" }}
            className="bg-white p-10 rounded-3xl border border-orange-100 relative overflow-hidden group"
          >
            <div className="absolute top-0 right-0 w-24 h-24 bg-orange-50 rounded-bl-full opacity-50 group-hover:bg-orange-500 transition-colors duration-500"></div>
            <Reveal>
              <span className="text-[#F26B1D] font-bold text-xs uppercase tracking-widest">Propósito</span>
              <h3 className="text-2xl font-extrabold text-[#1C1C1C] mt-2 italic">Nuestra Misión</h3>
              <p className="mt-4 text-gray-600 leading-relaxed">
                Transformar la gestión de la propiedad en el Perú mediante soluciones técnicas de <strong>ingeniería de alta precisión</strong> y asesoría legal estratégica, garantizando la <strong>seguridad jurídica</strong> de nuestros clientes.
              </p>
            </Reveal>
          </motion.div>

          {/* Tarjeta Visión */}
          <motion.div
            whileHover={{ y: -10, shadow: "0 20px 25px -5px rgb(0 0 0 / 0.1)" }}
            className="bg-white p-10 rounded-3xl border border-gray-100 relative overflow-hidden group"
          >
            <div className="absolute top-0 right-0 w-24 h-24 bg-gray-50 rounded-bl-full opacity-50 group-hover:bg-[#1C1C1C] transition-colors duration-500"></div>
            <Reveal>
              <span className="text-gray-400 font-bold text-xs uppercase tracking-widest">Futuro</span>
              <h3 className="text-2xl font-extrabold text-[#1C1C1C] mt-2 italic">Nuestra Visión</h3>
              <p className="mt-4 text-gray-600 leading-relaxed">
                Consolidarnos como la <strong>plataforma digital líder</strong> en servicios prediales a nivel nacional, siendo referentes por nuestra innovación tecnológica y por facilitar el acceso a servicios de ingeniería de calidad.
              </p>
            </Reveal>
          </motion.div>

        </div>
      </section>

      {/* POR QUE ELEGIRNOS */}
      <section className="py-24 bg-white">
        <div className="max-w-6xl mx-auto px-6">

          <Reveal>
            <h2 className="text-3xl font-bold text-center text-[#1C1C1C]">
              ¿Por qué elegir Planix?
            </h2>
          </Reveal>

          <div className="grid md:grid-cols-3 gap-10 mt-16">

            {[
              "Experiencia en gestión predial",
              "Planos técnicos profesionales",
              "Asesoría clara y confiable",
              "Soluciones personalizadas",
              "Atención rápida",
              "Herramientas digitales modernas"
            ].map((item, index) => (
              <Reveal key={index}>
                <div className="flex items-start gap-3">

                  <HiOutlineCheckCircle
                    size={24}
                    className="text-[#F26B1D] mt-1"
                  />

                  <p className="text-gray-600">{item}</p>

                </div>
              </Reveal>
            ))}

          </div>

        </div>
      </section>

      <Stats />

      {/* SECCIÓN VALORES */}
      <section className="py-24 bg-white">
        <div className="max-w-6xl mx-auto px-6 text-center">
          <Reveal>
            <span className="text-[#F26B1D] font-bold tracking-widest text-xs uppercase">Nuestros Pilares</span>
            <h2 className="text-3xl md:text-4xl font-extrabold text-[#1C1C1C] mt-3">
              Valores que definen a <span className="text-[#F26B1D]">Planix</span>
            </h2>
          </Reveal>

          <div className="grid md:grid-cols-3 gap-8 mt-16">
            {[
              {
                titulo: "Precisión Técnica",
                desc: "Rigurosidad en cada levantamiento y cálculo para garantizar la viabilidad de tus proyectos.",
                icon: "📐"
              },
              {
                titulo: "Integridad Legal",
                desc: "Asesoría transparente bajo la normativa SUNARP para asegurar tu propiedad.",
                icon: "⚖️"
              },
              {
                titulo: "Innovación",
                desc: "Uso de tecnología avanzada y drones para soluciones eficientes y modernas.",
                icon: "🚀"
              }
            ].map((valor, i) => (
              <Reveal key={i}>
                <motion.div
                  whileHover={{ scale: 1.05 }}
                  className="p-8 bg-gray-50 rounded-2xl border border-gray-100 hover:bg-white hover:shadow-xl transition-all duration-300"
                >
                  <div className="text-4xl mb-4">{valor.icon}</div>
                  <h4 className="text-xl font-bold text-gray-900 mb-3">{valor.titulo}</h4>
                  <p className="text-gray-600 text-sm leading-relaxed">{valor.desc}</p>
                </motion.div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* CTA REIMAGINADO */}
      <section className="relative py-24 overflow-hidden">
        {/* Fondo con un degradado que saca del negro total pero mantiene el contraste */}
        <div className="absolute inset-0 bg-gradient-to-br from-[#1C1C1C] via-[#2D2D2D] to-[#1C1C1C]"></div>

        {/* Círculos decorativos sutiles para dar profundidad (ingeniería digital) */}
        <div className="absolute -top-24 -left-24 w-96 h-96 bg-[#F26B1D]/10 rounded-full blur-3xl"></div>
        <div className="absolute -bottom-24 -right-24 w-80 h-80 bg-blue-500/5 rounded-full blur-3xl"></div>

        <div className="relative max-w-4xl mx-auto px-6 text-center text-white">
          <Reveal>
            <span className="text-[#F26B1D] font-extrabold tracking-[0.2em] text-xs uppercase mb-4 block">
              ¿Listo para empezar?
            </span>
            <h2 className="text-3xl md:text-5xl font-extrabold tracking-tight leading-tight">
              Lleva tu propiedad al <br />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-white to-gray-400">
                Siguiente Nivel Legal
              </span>
            </h2>
          </Reveal>

          <Reveal>
            <p className="mt-8 text-gray-400 text-lg max-w-2xl mx-auto leading-relaxed">
              Desde la elaboración de planos hasta la inscripción en <strong>SUNARP</strong>.
              Brindamos la asesoría técnica que tu proyecto de ingeniería civil necesita.
            </p>
          </Reveal>

          <Reveal>
            <div className="mt-12 flex flex-col sm:flex-row gap-4 justify-center items-center">
              <a
                href="/contacto"
                rel="noopener noreferrer"
                className="group relative inline-flex items-center justify-center bg-[#F26B1D] px-10 py-4 rounded-full font-bold text-white transition-all duration-300 hover:shadow-[0_0_30px_rgba(242,107,29,0.4)] hover:-translate-y-1"
              >
                <span>Contactar un Experto</span>
                <svg className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7l5 5m0 0l-5 5m5-5H6" />
                </svg>
              </a>

              <a
                href="https://wa.me/51983974833"
                target="_blank"
                rel="noopener noreferrer"
                className="px-10 py-4 rounded-full font-bold border border-white/20 hover:bg-white/5 transition-all"
              >
                Consultoría Rápida
              </a>
            </div>
          </Reveal>
        </div>
      </section>

      <LogoMarquee />

    </div>
  );
};

export default About;